import React from "react";
import UnAuthorized from "../components/unauthorizedUser/UnAuthorized";

const GuardedRoute = ({ Component, authorized }) => {
  return authorized ? Component : <UnAuthorized />;
};

export default GuardedRoute;
